import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BottomBarComponent } from '../components/bottom-bar/bottom-bar.component';

@Component({
  selector: 'app-changelog',
  imports: [BottomBarComponent],
  templateUrl: './changelog.component.html',
  styleUrl: './changelog.component.scss'
})
export class ChangelogComponent implements OnInit {
  changelogHtml = ''

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get('assets/CHANGELOG.md', { responseType: 'text' }).subscribe({
      next: (md) => {
        this.changelogHtml = this.markdownToHtml(md)
      },
      error: () => {
        this.changelogHtml = '<p>Changelog konnte nicht geladen werden.</p>'
      }
    })
  }

  private markdownToHtml(md: string): string {
    return md
      // Headers
      .replace(/^### (.+)$/gm, '<h3>$1</h3>')
      .replace(/^## (.+)$/gm, '<h2>$1</h2>')
      .replace(/^# (.+)$/gm, '<h1>$1</h1>')
      // Bold
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      // Italic
      .replace(/\*\((.+?)\)\*/g, '<em>($1)</em>')
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
      // List items
      .replace(/^- (.+)$/gm, '<li>$1</li>')
      // Wrap consecutive li in ul
      .replace(/(<li>.*<\/li>\n?)+/g, '<ul>$&</ul>')
      // Paragraphs
      .replace(/\n{2,}/g, '\n')
      // HTML comments (git-cliff group markers)
      .replace(/<!--.*?-->/g, '')
      // Remaining newlines
      .replace(/\n/g, '')
  }
}
